import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonLibService } from '@lib/services';
import { SupportComponent } from '@lib/components/support-class';
import { ReceiptSelectService } from '@common/services';

@Component({
  selector: 'asw-receipt-select-sub-header',
  templateUrl: './receipt-select-sub-header.component.html',
  styleUrls: ['./receipt-select-sub-header.component.scss'],
  providers: [ReceiptSelectService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReceiptSelectSubHeaderComponent extends SupportComponent {
  /** ページタイトル */
  pageTitle?: string;

  /** 遷移元のURL */
  backUrl;

  constructor(commonLibService: CommonLibService, _receiptSelectService: ReceiptSelectService) {
    super(commonLibService);
    this.backUrl = _receiptSelectService.previousPageRoutes;
  }

  reload(): void {}
  init(): void {}
  destroy(): void {}
}
